import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import { authorizeMeta } from './guards';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior(to) {
    //アンカーリンクが設定されている場合にはその地点へとスクロールする
    let selector = {};
    if (to.hash) {
      selector.selector = to.hash;
      //オフセットを設定すべきページかどうかを判定
      if (to.path.indexOf('/help') >= 0) {
        //該当ページのオフセット値を設定
        //selector.offset = { y: 54 };//どうやらVueの現行バージョンではoffsetを指定できないので、CSSで頑張るしかなさそう
      }
    } else {
      //アンカーリンクが設定されていない場合は現行位置で表示
      return;
    }
    return selector;
  }
});
router.beforeEach(authorizeMeta);

export default router;
